import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./feature/feature.routes').then((m) => m.routes),
  },
  {
    path: 'switch-organisation',
    loadComponent: () =>
      import('./pages/switch-organisation/switch-organisation.component').then((m) => m.SwitchOrganisationComponent),
  },
  {
    path: 'logout',
    loadComponent: () => import('./pages/logout/logout.component').then((m) => m.LogoutComponent),
  },
  {
    path: 'geen-toegang',
    loadComponent: () => import('./pages/unauthorized/unauthorized.component').then((m) => m.UnauthorizedComponent),
  },
  {
    path: 'pagina-niet-gevonden',
    loadComponent: () => import('./pages/page-not-found/page-not-found.component').then((m) => m.PageNotFoundComponent),
  },
  {
    path: '**',
    pathMatch: 'full',
    loadComponent: () => import('./pages/page-not-found/page-not-found.component').then((m) => m.PageNotFoundComponent),
  },
];
